import useSWR, { type KeyedMutator } from 'swr';
import { getReportEventsCacheKey } from '@/constants/cache-keys';
import { EngineService } from '@/services/engine';
import type { ReportEvent, ReportWithEvents } from '@/types/report';
import { DEFAULT_CONFIDENCE_THRESHOLD } from '@/utils/query-filters';

const NO_EVENTS: ReportEvent[] = [];

interface UseReportEventsDataResult {
    events: ReportEvent[];
    isLoading: boolean;
    mutate: KeyedMutator<ReportWithEvents>;
}

export function useReportEventsData(
    reportId: string,
): UseReportEventsDataResult {
    const { data, isLoading, mutate } = useSWR(
        reportId
            ? getReportEventsCacheKey(reportId, DEFAULT_CONFIDENCE_THRESHOLD)
            : null,
        () =>
            EngineService.getReportWithEvents(reportId, {
                minConfidence: DEFAULT_CONFIDENCE_THRESHOLD,
            }),
        {
            revalidateOnFocus: false,
        },
    );

    return {
        events: data?.events ?? NO_EVENTS,
        isLoading: !data && isLoading,
        mutate,
    };
}
